import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_catalog_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  ranks: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  applet_store_guid: fromDatatype.GuidDataFieldInterface;
  catalog_type: fromDatatype.VarcharDatatypeInterface;
  access_type: fromDatatype.VarcharDatatypeInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface
}

export class bl_applet_catalog_hdr_RowClass
  implements bl_applet_catalog_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  subscription_hdr_guid: fromDatatype.GuidDataFieldInterface;
  property_json: any;
  ranks: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  applet_store_guid: fromDatatype.GuidDataFieldInterface;
  catalog_type: fromDatatype.VarcharDatatypeInterface;
  access_type: fromDatatype.VarcharDatatypeInterface;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface
}
